let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Ilth")).then(() => parcelRequire('lRr5d'));